import { resolveFonts } from "@keepoinc/site-page-react-component";

import { Site } from "./site";
import { preDefinedThemes } from "./theme";

const sameFonts = (fonts: Site["fonts"]) => {
  const chosen = resolveFonts(fonts);
  const standard = resolveFonts(undefined);
  return chosen.heading === standard.heading && chosen.body === standard.body;
};

/**
 * The look's PLUS items, as the Personalizar screen marks them: the top (all but the classic), the colors (a palette
 * of their own, the titles' color), the background, the buttons' style, the alignment, the fonts and the footer
 * without the Keepo brand. A palette, the photo and the icons' look are free.
 */
export const siteUsesPlusStyle = (site?: Site): boolean => {
  if (!site) {
    return false;
  }
  const theme = site.theme;
  return (
    theme.id === "custom" ||
    !!theme.background ||
    !!theme.buttonStyle ||
    !!theme.titleColor ||
    (!!theme.header && theme.header.style !== "classic") ||
    (site.layout?.align ?? "LEFT") !== "LEFT" ||
    !sameFonts(site.fonts) ||
    !!site.hideSignature
  );
};

/**
 * The free version of the look ("Usar a versão simples"): every PLUS item back to its standard (the first palette for
 * colors of its own, the classic top, the fonts as always). The photo, the palette already free and the icons' look stay.
 */
export const toFreeStyle = (site: Site): Site => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { background, buttonStyle, titleColor, header, ...colors } = site.theme;
  const palette = colors.id === "custom" ? preDefinedThemes[0] : colors;
  return {
    ...site,
    theme: { ...palette, iconShape: colors.iconShape, iconFill: colors.iconFill },
    layout: { ...site.layout, align: "LEFT" },
    fonts: undefined,
    hideSignature: false,
  };
};

/**
 * What an already published FREE Keepo goes on the air with: only colors of its own and the alignment, the two PLUS
 * items the editor always reset on publishing, go back to the standard. The rest of its look stays as it was
 * published (nothing changes on a live page without notice); toFreeStyle is for a Keepo not yet on the air.
 */
export const resetPlusStyleFeatures = (site: Site): Site => ({
  ...site,
  theme: site.theme.id === "custom" ? preDefinedThemes[0] : site.theme,
  layout: { ...site.layout, align: "LEFT" },
});
